import { atom, useAtomValue, useSetAtom } from "jotai";

export const passedPropertyWizardSectionAtom = atom<boolean>(false);

export const useSetPassedPropertyWizardSection = () => useSetAtom(passedPropertyWizardSectionAtom);
export const usePassedPropertyWizardSectionValue = () => useAtomValue(passedPropertyWizardSectionAtom);
